import { render } from "./SKUDataTablePage.vue?vue&type=template&id=2979b43e"
import script from "./SKUDataTablePage.vue?vue&type=script&lang=js"
export * from "./SKUDataTablePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__